
import bowser from 'bowser';
import navigationViewport from './navigation--viewport.js';

  navigationViewport.then(function() {
    var mainMenu = document.querySelector('.main-menu');
    var navigation = document.querySelector('.main-menu__navigation');
    var changeEventName = 'change';

    if (bowser.ios) { // This is ugly, and I don't know why it doesn't work without it in iOS
      Array.prototype.forEach.call(document.querySelectorAll('.navigation__item-trigger,.navigation__item-link[for]'), function(trigger) {
        trigger._for = trigger.getAttribute('for');
        trigger.removeAttribute('for');
        trigger.addEventListener('tap', toggleItemState);
      });
      changeEventName = 'custom-change';
    }

    function toggleItemState(event) {
      var itemState = document.getElementById(event.target._for);
      if (!itemState) {
        return;
      }
      itemState.checked = !itemState.checked;
      itemState.dispatchEvent(new CustomEvent(changeEventName, {bubbles: true}));
    }

    function itemStateListener(event) {
      var itemState = event.target;
      var parentItem = itemState.parentNode;
      var parentNavigation = parentItem.parentNode;

      if (!itemState.classList.contains('navigation__item-state') || !parentItem.classList.contains('navigation__item')) {
        return;
      }

      if (parentItem.classList.contains('navigation__item--main') || parentItem.classList.contains('navigation__item--service')) {
        parentNavigation = parentNavigation.parentElement;
      }

      var siblingStates = parentNavigation.querySelectorAll('.navigation__item .navigation__item-state:checked');
      for (var i = 0; i < siblingStates.length; i++) {
        var sibling = siblingStates[i];
        if (sibling !== itemState) {
          sibling.checked = false;
        }
      }

      var clickedItemTop = parentItem.getBoundingClientRect().top;
      if (clickedItemTop < 48) { // 48 eqs 3rem of top-bar
        mainMenu.scrollTop = parentItem.offsetTop; // should be parentItem.scrollIntoView();, but well… iOS
      }
    }

    function initItemStateOrganizer() {
      if (null === navigation) {
        return;
      }

      if (window.fitNavigationViewport === 'mobile') {
        navigation.addEventListener(changeEventName, itemStateListener);
      } else {
        navigation.removeEventListener(changeEventName, itemStateListener);
      }
    }

    document.body.addEventListener('navigationChange', initItemStateOrganizer());
    initItemStateOrganizer();
  });
